define("shared/components/shared/linkinbio/item/shopify-product", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _object, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li
    class="cLB--list__item o--list__item--img
      {{if this.isDescriptionExpanded "cLB--list__item--open"}}"
    onclick={{fn @setProduct @product}}
  >
    {{!  Product Images }}
    <div class="o--list__image">
      <figure class="o--mediaContainer">
        {{#each @product.images as |image|}}
          <img src={{image.src}} class="o--media">
        {{/each}}
        <b class="o--mediaOverlay"></b>
      </figure>
    </div>
    {{!  Product Title }}
    <h4
      class={{concat "o--list__title qa--shopify_product_title " (if this.isDescriptionExpanded "u--p__t__md" "u--ellipsis")}}
    >
      {{@product.title}}
    </h4>
    <div class="cLB--list__text qa--shopify_product_price">
      {{!  Product Price }}
      {{#if this.isDescriptionExpanded}}
        <p>
          {{html-safe this.priceString}}
        </p>
      {{/if}}
      {{!  Product Description }}
      {{#if @product.description}}
        <p
          class="u--m__b__0 u--p__r__lg
            {{if this.isDescriptionExpanded "" "u--ellipsis"}}"
        >
          {{@product.description}}
        </p>
      {{else}}
        <p class="u--text--light u--m__b__0">
          {{t "shopify.product.no_description"}}
        </p>
      {{/if}}
    </div>
    {{!  Expand/Collapse Icon }}
    <i
      class="{{if this.isDescriptionExpanded "i-nav-up" "i-nav-down"}}
         cLB--list__icon"
      onclick={{this.toggleDescriptionExpanded}}
    ></i>
    {{!  Overlay: Select Product }}
    <span class="o--list__action--hide">
      {{t "shared_phrases.select_product"}}
    </span>
  </li>
  */
  {
    "id": "IXHzoF9N",
    "block": "[[[10,\"li\"],[15,0,[29,[\"cLB--list__item o--list__item--img\\n    \",[52,[30,0,[\"isDescriptionExpanded\"]],\"cLB--list__item--open\"]]]],[15,\"onclick\",[28,[37,1],[[30,1],[30,2]],null]],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"o--list__image\"],[12],[1,\"\\n    \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,2,[\"images\"]]],null]],null],null,[[[1,\"        \"],[10,\"img\"],[15,\"src\",[30,3,[\"src\"]]],[14,0,\"o--media\"],[12],[13],[1,\"\\n\"]],[3]],null],[1,\"      \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,\"h4\"],[15,0,[28,[37,4],[\"o--list__title qa--shopify_product_title \",[52,[30,0,[\"isDescriptionExpanded\"]],\"u--p__t__md\",\"u--ellipsis\"]],null]],[12],[1,\"\\n    \"],[1,[30,2,[\"title\"]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cLB--list__text qa--shopify_product_price\"],[12],[1,\"\\n\"],[41,[30,0,[\"isDescriptionExpanded\"]],[[[1,\"      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,5],[[30,0,[\"priceString\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,2,[\"description\"]],[[[1,\"      \"],[10,2],[15,0,[29,[\"u--m__b__0 u--p__r__lg\\n          \",[52,[30,0,[\"isDescriptionExpanded\"]],\"\",\"u--ellipsis\"]]]],[12],[1,\"\\n        \"],[1,[30,2,[\"description\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,2],[14,0,\"u--text--light u--m__b__0\"],[12],[1,\"\\n        \"],[1,[28,[35,6],[\"shopify.product.no_description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,\"i\"],[15,0,[29,[[52,[30,0,[\"isDescriptionExpanded\"]],\"i-nav-up\",\"i-nav-down\"],\"\\n       cLB--list__icon\"]]],[15,\"onclick\",[30,0,[\"toggleDescriptionExpanded\"]]],[12],[13],[1,\"\\n\"],[1,\"  \"],[10,1],[14,0,\"o--list__action--hide\"],[12],[1,\"\\n    \"],[1,[28,[35,6],[\"shared_phrases.select_product\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@setProduct\",\"@product\",\"image\"],false,[\"if\",\"fn\",\"each\",\"-track-array\",\"concat\",\"html-safe\",\"t\"]]",
    "moduleName": "shared/components/shared/linkinbio/item/shopify-product.hbs",
    "isStrictMode": false
  });

  let ShopifyProductComponent = (_class = class ShopifyProductComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "shopify", _descriptor, this);

      _initializerDefineProperty(this, "isDescriptionExpanded", _descriptor2, this);
    }

    get priceString() {
      return this.shopify.getProductPriceString(this.args.product);
    }

    toggleDescriptionExpanded(event) {
      event.stopPropagation();
      this.isDescriptionExpanded = !this.isDescriptionExpanded;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "shopify", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isDescriptionExpanded", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleDescriptionExpanded", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleDescriptionExpanded"), _class.prototype)), _class);
  _exports.default = ShopifyProductComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ShopifyProductComponent);
});